import { AxiosInstance } from 'axios'

export function senEmailEndpoints(apiClient: AxiosInstance) {
  return {
    async createUserPassword(login: string, pharmaceuticalId: number): Promise<void> {
      return apiClient.post(`send-email-to-create-user-password`, { login, pharmaceuticalId })
    },
  }
}
